'use client'
import * as Tooltip from '@radix-ui/react-tooltip'
import React from 'react'

type DMTooltipProps = {
   id?: string
   open?: boolean
   triggerContent: React.ReactNode
   tooltipContent: React.ReactNode
}

function DMTooltip({
   id,
   open,
   triggerContent,
   tooltipContent,
}: DMTooltipProps) {
   const conditionalProp = open !== undefined ? { open } : {}

   return (
      <Tooltip.Provider delayDuration={0}>
         <Tooltip.Root {...conditionalProp}>
            <Tooltip.Trigger asChild id={id}>
               {triggerContent}
            </Tooltip.Trigger>

            {tooltipContent && (
               <Tooltip.Portal>
                  <Tooltip.Content
                     className={
                        'z-[100] max-w-[400px] bg-slate-100 !text-black data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade text-violet11 select-none rounded-[4px] px-[15px] py-[10px] text-[15px] leading-none shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] will-change-[transform,opacity]'
                     }
                     sideOffset={5}
                     data-side="top"
                  >
                     {tooltipContent}
                     <Tooltip.Arrow className="fill-slate-100" />
                  </Tooltip.Content>
               </Tooltip.Portal>
            )}
         </Tooltip.Root>
      </Tooltip.Provider>
   )
}

export default DMTooltip
